import Capacity from './capacity';

export default class Airplane {
  data = null;

  capacity = null;

  constructor (data) {
    this.data = data;
    if (data.capacity) this.capacity = new Capacity(data.capacity);
  }

  get id () {
    return this.data.id;
  }

  get airplane () {
    return this.data.iataAirplane || this.data.type;
  }

  get type () {
    return this.data.type;
  }

  get number () {
    return this.data.regNum || this.data.number;
  }

  get companyMarker () {
    return this.data.marker;
  }

  get abilityProps () {
    return { company: this.companyMarker };
  }

  get fullName () {
    return `${this.airplane} ${this.number}`;
  }
};
